import TryAPI from '../TryAPI';

export const GEOCODE_STARTED = 'GEOCODE_STARTED';
export const GEOCODE_FAILED = 'GEOCODE_FAILED';
export const GEOCODE_COMPLETED = 'GEOCODE_COMPLETED';

export function geocode(query, fields, direction) {
    if (history.pushState) {
        const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?q=' + encodeURIComponent(query);
        window.history.pushState(
            {
                path: newUrl
            },
            '',
            newUrl
        );
    }

    return dispatch => {
        dispatch(geocodeStarted(query, fields, direction));

        return TryAPI.geocode(query, fields, direction)
            .then(response => response.json())
            .then(json => dispatch(geocodeCompleted(json)))
            .catch(ex => dispatch(geocodeFailed(ex.message)));
    };
}

export function geocodeStarted(query, fields, direction) {
    return {
        type: GEOCODE_STARTED,
        query,
        fields,
        direction
    };
}

export function geocodeFailed(errorMessage) {
    return {
        type: GEOCODE_FAILED,
        errorMessage
    };
}

export function geocodeCompleted(response) {
    return {
        type: GEOCODE_COMPLETED,
        response
    };
}
